import {useDispatch} from "react-redux";

import {Notifications as DSNotifications} from "@pg-design/notifications";

import {useAppSelector} from "../../../store/hooks/use_app_selector";
import {removeNotification} from "../state/notifications_slice";

export const Notifications = () => {
    const dispatch = useDispatch();

    const notifications = useAppSelector((state) => state.notifications);

    return <DSNotifications notifications={notifications} removeNotification={(id) => dispatch(removeNotification(id))} />;
};
import {useDispatch} from "react-redux";

import {Notifications as DSNotifications} from "@pg-design/notifications";

import {useAppSelector} from "../../../store/hooks/use_app_selector";
import {removeNotification} from "../state/notifications_slice";

export const Notifications = () => {
    const dispatch = useDispatch();

    const notifications = useAppSelector((state) => state.notifications);

    return <DSNotifications notifications={notifications} removeNotification={(id) => dispatch(removeNotification(id))} />;
};
